/**
 * Static UI metadata for the Browser Agent Sites view (KIR-4703 / KIR-4704).
 *
 * The table rows come from the real read-API (the shared table's server
 * fetch); this holds only per-agent-type presentation
 * (enforcement options, labels, descriptions).
 */

export type AgentType =
  | 'chrome_via_cli'
  | 'chrome_via_browser'
  | 'claude_code_cli';

/** Enforcement state. 'monitor' only offered for browser-internal use. */
export type Enforcement = 'approve' | 'block' | 'monitor';

export interface AgentTypeMeta {
  /** Enforcement options this type offers (Block only where enforceable). */
  options: Enforcement[];
  /** One-line description shown in the expanded detail panel. */
  description: string;
}

export const AGENT_TYPE_META: Record<AgentType, AgentTypeMeta> = {
  chrome_via_cli: {
    options: ['approve', 'block'],
    description:
      'The agent can use this site. Block stops navigations Claude Code sends to this site and its subdomains; clicks or redirects inside a page are not checked.',
  },
  chrome_via_browser: {
    options: ['approve', 'monitor'],
    // Product review #4: exactly this sentence, nothing more.
    description: 'We are watching this site.',
  },
  claude_code_cli: {
    options: ['approve', 'block'],
    description:
      'The Claude Code CLI can fetch from this site. Block stops fetches to this site and its subdomains.',
  },
};
